import React from 'react';
import { Wrench, Paintbrush, Ship, CheckCircle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { services } from '../data/mock';

const iconMap = {
  Wrench: Wrench,
  Paintbrush: Paintbrush,
  Ship: Ship
};

export const Services = () => {
  return (
    <section id="services" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider mb-2 block">
            Nossos Serviços
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            Excelência em Cada Detalhe
          </h2>
          <p className="text-lg text-slate-600">
            Oferecemos uma gama completa de serviços especializados para o seu veículo ou embarcação
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 border-slate-200 hover:border-blue-400 bg-white overflow-hidden"
              >
                <CardHeader className="relative pb-6">
                  {/* Icon Circle */}
                  <div className="w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center mb-4 group-hover:bg-blue-700 transition-colors duration-300 shadow-lg">
                    <IconComponent className="text-white" size={32} />
                  </div>
                  
                  <CardTitle className="text-2xl text-slate-800 group-hover:text-blue-700 transition-colors">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-slate-600 text-base mt-2">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                
                <CardContent>
                  <ul className="space-y-3">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <CheckCircle className="text-blue-600 flex-shrink-0 mt-0.5" size={18} />
                        <span className="text-slate-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>

                {/* Decorative Element */}
                <div className="h-1 bg-gradient-to-r from-blue-600 to-blue-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
              </Card>
            );
          })}
        </div>

        {/* Additional Info Banner */}
        <div className="mt-16 bg-gradient-to-r from-slate-800 to-slate-700 rounded-2xl p-8 md:p-12 text-center text-white shadow-xl">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Trabalho com Garantia de Qualidade
          </h3>
          <p className="text-slate-200 text-lg max-w-2xl mx-auto">
            Utilizamos apenas materiais de primeira linha e técnicas profissionais 
            para garantir resultados duradouros e acabamento impecável.
          </p>
        </div>
      </div>
    </section>
  );
};
